import { motion } from 'framer-motion';

const Benefits = () => {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Redução de Custos',
      description: 'Elimine gastos com manutenção, combustível e gestão de frota própria',
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Mais Agilidade',
      description: 'Entregas rápidas e eficientes que mantêm sua operação em movimento',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Garantida',
      description: 'Profissionais treinados e veículos preparados para transporte seguro',
    },
    {
      icon: 'ri-time-line',
      title: 'Pontualidade',
      description: 'Cumprimento rigoroso de prazos e horários estabelecidos',
    },
    {
      icon: 'ri-calendar-line',
      title: 'Flexibilidade',
      description: 'Atendimento sob demanda ou contratos mensais personalizados',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Escalabilidade',
      description: 'Soluções que crescem junto com as necessidades da sua empresa',
    },
  ];

  return (
    <section className="bg-[#1a237e] py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Por que Empresas Terceirizam a Logística com a RBF Express?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-start p-6 border-l-4 border-[#ff6f00] hover:bg-white/5 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                <i className={`${benefit.icon} text-3xl text-[#ff6f00]`}></i>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-bold text-white mb-2">{benefit.title}</h3>
                <p className="text-white/80 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
